import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';
import html2canvas from  'html2canvas';
//import domtoimage from 'dom-to-image';

@Component({
  selector: 'app-htmlcssjs',
  templateUrl: './htmlcssjs.component.html',
  styleUrls: ['./htmlcssjs.component.scss'],
})
export class HtmlcssjsComponent implements OnInit {

  @Input() code: string;
  @Input() id: number;
 
  codecss: string;
  codejs: string;


  @Output() eventchild = new EventEmitter<string>();

  @ViewChild('idhtml', { static: true }) idhtml: ElementRef;
  @ViewChild('idcss', { static: true }) idcss: ElementRef;
  @ViewChild('idjs', { static: true }) idjs: ElementRef;
  @ViewChild('idframe', { static: true }) idframe: ElementRef;
  @ViewChild('idback', { static: true }) idback: ElementRef;

  visicss: boolean = true;
  visijs: boolean = true;
  selection = "0";

  constructor(public gfichier: GfichierService) { }

  ngOnInit() { }

  ngOnChanges() {

   
      this.idhtml.nativeElement.innerText = this.code;
      let valeur = this.gfichier.getValue2(this.id, "css");
      if (valeur == undefined) {
        this.visicss = false;
        document.getElementById("css1").style.display = "none";

      }
      else {
        document.getElementById("css1").style.display = "block";
        this.visicss = true;
        this.codecss = valeur;
        this.idcss.nativeElement.innerText = valeur;
      }

      valeur = this.gfichier.getValue2(this.id, "js");
      if (valeur == undefined) {
        this.visijs = false;
        document.getElementById("js1").style.display = "none";

      }
      else {

        document.getElementById("js1").style.display = "block";
        this.visijs = true;
        this.codejs = valeur;
        this.idjs.nativeElement.innerText = valeur;
      }

      valeur = this.gfichier.getValue2(this.id, "selection");
      if (valeur == undefined) {
        this.selection = "2";
      }
      else {
        this.selection = String(valeur);
      }
      
    this.selectionChange();
  
  }



  selectionChange() {
    if (this.selection == "0") {
      this.idframe.nativeElement.style.width = "240px";
      this.idframe.nativeElement.style.height = "400px";
   //   this.idback.nativeElement.style.padding = "15px";
    } else if (this.selection == "3") {
      this.idframe.nativeElement.style.width = "130px";
      this.idframe.nativeElement.style.height = "130px";
   //   this.idback.nativeElement.style.padding = "10px";
    } else if (this.selection == "1") {
      this.idframe.nativeElement.style.width = "340px";
      this.idframe.nativeElement.style.height = "500px";
   //   this.idback.nativeElement.style.padding = "15px";
    } else if (this.selection == "2") {
      this.idframe.nativeElement.style.width = "100%";
      setTimeout(() => {
        this.idframe.nativeElement.style.height = "450px";//this.idframe.nativeElement.style.width*3;
   //     this.idback.nativeElement.style.padding = "15px";
    
      },1000); }

  }



  aChanger() {
    // alert(this.idtexte.nativeElement.innerHTML);
    this.code = this.idhtml.nativeElement.innerText;
    this.gfichier.setValue(this.code, this.id, "htm");

    if (this.visicss) {

      this.codecss = this.idcss.nativeElement.innerText;
      this.gfichier.setValue(this.codecss, this.id, "css");

    }

    if (this.visijs) {
      this.codejs = this.idjs.nativeElement.innerText;
      this.gfichier.setValue(this.codejs, this.id, "js");
    }

  }


  compiler() {
    let doc = this.idframe.nativeElement.contentDocument || this.idframe.nativeElement.contentWindow;
    doc.open();
    doc.write("");
    doc.close();

    doc.open();
    //doc.html.innerHTML="";
    doc.write(this.code);

    if (this.visicss) {
      let lestyle = "<style>" + this.codecss + "</style>";
      doc.write(lestyle);
    }
    if (this.visijs) {
      let lejs = "<script>" + this.codejs + "</script>";
      doc.write(lejs);
    }

    doc.close();
    
    setTimeout(() => {
      
    
    let  content= doc.getElementsByTagName('html')[0];
    //let  content= document.getElementById('capture');
    //alert(content);
        html2canvas(content).then(canvas => {
           //    document.body.appendChild(canvas)
           //alert(canvas);
           let dataURL = canvas.toDataURL();
           //alert(dataURL);
           this.gfichier.setValue(dataURL , this.id, "output");
        
          });
        }, 500);

   
    }//fin compile

   

}
